import axios from "axios";

// type HttpMethod = "GET" | "POST" | "PUT" | "DELETE";

const baseUrl = location.origin;

async function apiCall(
  method,
  url,
  data,
  config = {},
) {
  try {
    const response = await axios({
      method,
      url,
      data,
      ...config,
    });
    return response.data;
  } catch (error) {
    if (error?.response?.data) {
      // Include response data in the thrown error object
      throw error.response.data;
    } else {
      throw new Error(error.message);
    }
  }
}

export async function getItems(url) {
  const items = await apiCall("GET", baseUrl + url);
  return items;
}

export async function postItem(
  url,
  payload
) {
  const newItem = await apiCall("POST", baseUrl + url, payload);
  return newItem;
}

export async function putItem(
    url,
    payload
) {
  const newItem = await apiCall("PUT", baseUrl + url, payload);
  return newItem;
}

export async function deleteItem(url) {
  const newItem = await apiCall("DELETE", baseUrl + url);
  return newItem;
}
